import axios from "axios";
import { z } from "zod";
import { toast } from "../../../components/ui/use-toast";
import { CircleCheckBig } from "lucide-react";
const baseUrl = process.env.REACT_APP_SERVER_URL;

export const getAllSupports = async () => {
  try {
    const response = await axios.get(`${baseUrl}/api/supports`);
    return { supports: response.data.supports };
  } catch (error) {
    console.error(error);
  }
};

export const getAllPaginatedSupports = async (page: number) => {
  try {
    const response = await axios.get(
      `${baseUrl}/api/supports/all?page=${page}`
    );
    return {
      supports: response.data.supports,
      count: response.data.count,
      totalPages: response.data.totalPages,
    };
  } catch (error) {
    console.error(error);
  }
};

export const handleCreateSupports = async (
  formData: any,
  navigate: Function
) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "multipart/form-data",
      },
    };

    const newsFormData = new FormData();

    for (const key in formData) {
      if (formData.hasOwnProperty(key) && key !== "file") {
        if (formData[key] !== undefined && formData[key] !== null) {
          if (Array.isArray(formData[key])) {
            newsFormData.append(key, JSON.stringify(formData[key]));
          } else {
            newsFormData.append(key, formData[key]);
          }
        }
      }
    }

    if (formData.file) {
      newsFormData.append(`file`, formData.file.file);
    }

    const response = await axios.post(
      `${baseUrl}/api/supports/`,
      newsFormData,
      config
    );

    toast({
      variant: "destructive",
      className: "bg-green-500 border border-green-500",
      description: (
        <div className="flex items-center">
          <CircleCheckBig className="mr-2" />
          <span className="first-letter:capitalize">{response.data.msg}</span>
        </div>
      ),
    });
    navigate("/admin-dashboard/mediatheque/support-de-communications");
  } catch (error: any) {
    if (error instanceof z.ZodError) {
      const fieldErrors: { [key: string]: string } = {};
      error.errors.forEach((err: any) => {
        fieldErrors[err.path[0]] = err.message;
      });
    } else {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast({
          variant: "destructive",
          title: "Une erreur s'est produite.",
          description: error.response.data.message,
          className: "bg-red-500 border border-red-500",
        });
        return error.response.data.message;
      }
    }
  }
};

export const handleUpdateSupports = async (
  id: number,
  formData: any,
  navigate: Function
) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "multipart/form-data",
      },
    };

    const formDataToSend = new FormData();
    formDataToSend.append("title", formData.title);

    if (formData.file) {
      formDataToSend.append("file", formData.file.file);
    }

    const response = await axios.patch(
      `${baseUrl}/api/supports/${id}`,
      formDataToSend,
      config
    );
    toast({
      variant: "destructive",
      title: "Opération réussie.",
      description: response.data.msg,
      className: "bg-green-500 border border-green-500",
    });
    navigate("/admin-dashboard/mediatheque/support-de-communications");
  } catch (error: any) {
    if (error instanceof z.ZodError) {
      const fieldErrors: { [key: string]: string } = {};
      error.errors.forEach((err: any) => {
        fieldErrors[err.path[0]] = err.message;
      });
    } else {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast({
          variant: "destructive",
          title: "Une erreur s'est produite.",
          description: error.response.data.message,
          className: "bg-red-500 border border-red-500",
        });
        return error.response.data.message;
      }
    }
  }
};

export const deleteSupports = async (id: number) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    };

    const response = await axios.delete(
      `${baseUrl}/api/supports/${id}`,
      config
    );
    toast({
      variant: "destructive",
      className: "bg-green-500 border border-green-500",
      description: (
        <div className="flex items-center">
          <CircleCheckBig className="mr-2" />
          <span className="first-letter:capitalize">
            {response.data.message}
          </span>
        </div>
      ),
    });

    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getSupportsById = async (id: number) => {
  try {
    const response = await axios.get(`${baseUrl}/api/supports/${id}`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
